import React, { useState } from 'react';

import { ArrowDown } from '../../icons';
import {
  StyledArrow,
  StyledCalendarContainer,
  StyledCalendarMonth,
  StyledYearContainer,
  StyledWrapper,
} from './SimpleCalendar.styles';
import { ISimpleCalendarProps } from './SimpleCalendar.types';

const thisYear = new Date().getFullYear();
const thisMonth = new Date().getMonth();

const SimpleCalendar = ({
  months,
  selectedDate,
  user = 'tenant',
  onDateSelected,
}: ISimpleCalendarProps): JSX.Element => {
  const selectedDateYear = selectedDate && selectedDate.getFullYear();
  const selectedDateMonth = selectedDate && selectedDate.getMonth();
  const [selectedYear, setSelectedYear] = useState<number>(
    selectedDateYear ?? thisYear,
  );
  const [selectedMonth, setSelectedMonth] = useState<number>(
    selectedDateMonth ?? thisMonth,
  );

  const yearClickHandler = (num: number) => {
    const newSelectedYear = selectedYear + num;
    setSelectedYear(newSelectedYear);
    onDateSelected(new Date(newSelectedYear, selectedMonth, 1));
  };

  const monthClickHandler = (index: number) => {
    setSelectedMonth(index);
    onDateSelected(new Date(selectedYear, index, 1));
  };

  return (
    <StyledWrapper>
      <StyledYearContainer>
        {selectedYear && selectedYear > thisYear ? (
          <StyledArrow left onClick={() => yearClickHandler(-1)}>
            <ArrowDown />
          </StyledArrow>
        ) : (
          <StyledArrow noHover />
        )}

        {selectedYear}
        <StyledArrow onClick={() => yearClickHandler(1)}>
          <ArrowDown />
        </StyledArrow>
      </StyledYearContainer>
      <StyledCalendarContainer>
        {months.map((month, index) => (
          <StyledCalendarMonth
            selected={selectedMonth === index}
            onClick={() => selectedMonth !== index && monthClickHandler(index)}
            key={index}
            user={user}
          >
            {month}
          </StyledCalendarMonth>
        ))}
      </StyledCalendarContainer>
    </StyledWrapper>
  );
};

export default SimpleCalendar;
